


    import React ,{useRef ,useState } from 'react'
    import {updateDoc,doc} from "firebase/firestore";
    import {auth,storage ,db, functions} from '../../firebase.js'
    import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
    import Image from '../ui/Image-utilities/Image'
    import d132 from './QuestionNoteForm.module.css'
    import d13 from './SendQuestionsForm.module.css'
    
    
    
    import {BsImageFill ,BsFillReplyAllFill} from 'react-icons/bs'
    import{AiTwotoneAudio} from 'react-icons/ai'
    import{IoImagesOutline, IoText} from 'react-icons/io5'
    import {RiLoader4Line} from 'react-icons/ri'
   
    
    import RecorderHooks from '../ui/Audio-utilities/RecorderHook';
import { toast } from 'react-toastify';
import { httpsCallable } from 'firebase/functions';
    function QuestionNoteForm(props)  {
    const scroll = useRef();
      
      const [loader, setLoader] = useState(false);
    
      const [imgProgress, setImgProgress] = useState(0);
      const [imgUrl, setImgUrl] = useState("");
      const [imgUpState, setImgUpState] = useState(true);
      const [imagePreview, setImagePreview] = useState('')
    
      const [audioProgress, setAudioProgress] = useState(0);
      const [audioUrl, setAudioUrl] = useState("");
      const [audioUpState, setAudioUpState] = useState(true);
      const [audioPreview, setAudioPreview] = useState('')
     
       
        const questRef = useRef();
        const imgRef = useRef();
        const audioRef=useRef();
       
      let notificationFunction = httpsCallable(functions, 'sendReplyNotification');

    
    //audio & image preview
      function getImagePreview(){
        const url = URL.createObjectURL(imgRef.current.files[0]);
        setImagePreview(url);
      }
    
      function getAudioPreview(){
        const url2 = URL.createObjectURL(audioRef.current.files[0]);
        setAudioPreview(url2);
      }
    
       function handleImgUpload() {
          let enteredImg= imgRef.current.files[0]; //ref
          if (!enteredImg)return;
          console.log(enteredImg)
          // Create the file metadata
          /* @type {any} */
          const metadata = { contentType: 'image/jpeg-jpg-jpeg' };
        
          const storageRef = ref(storage, 'questions/'+auth.currentUser.uid+'/images/'+ (new Date().toString().substring(0,25))); 
          const uploadTask = uploadBytesResumable(storageRef, enteredImg, metadata);
          uploadTask.on('state_changed',
            (snapshot) => {
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              setImgProgress(progress);
            },{},
            (snapshot) => { 
              getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
               
                setImgUrl(downloadURL);
                setImgUpState(true);
                scroll.current.scrollIntoView({ behavior: 'smooth' })
              }).catch(()=>{toast.error("could not get the Image download URL "); setImgUpState(true);});
            }
          );
          
        }
      
         function handleAudioUpload(file) {
         // const enteredAudio= audioRef.current.files[0]; //ref
         const enteredAudio=file;
        if (!enteredAudio)return;
          setAudioUpState(false);
          // Create the file metadata
          /* @type {any} */
          const metadata = { contentType: 'audio/*' };
          const storageRef = ref(storage, 'questions/'+auth.currentUser.uid+'/audios/'+ ( new Date().toString().substring(0,25)) );
          const uploadTask = uploadBytesResumable(storageRef, enteredAudio, metadata);
          uploadTask.on('state_changed',
            (snapshot) => {
               const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
               setAudioProgress(progress);
             }, {},
             () => { 
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                 setAudioUrl(downloadURL);
                 setAudioUpState(true);
                 scroll.current.scrollIntoView({ behavior: 'smooth' })
               }).catch(()=>{toast.error("could not get the audio download URL "); setAudioUpState(true);});
             }
           );
           
        }
      
       
    
    
       
        function sendQuestion(){
       
        setLoader(true);
       
        async function addToDatabase()
        {
          
          
        
         
          const enteredQuestion=questRef.current.value; 
         
          await updateDoc(doc(db, "questions", props.question_id), {
          question_note:enteredQuestion,
          question_note_img:imgUrl,
          question_note_audio:audioUrl,
          question_reply:true,
          
          }
          ).then(()=>{
            notificationFunction().then((e)=>console.log(e))
          }

          ); 
          
        
         setLoader(false);
       } 
    
      
       addToDatabase();
     
      
      }
    //auto resize text area
     function textareaResize(){ const tx = document.getElementsByTagName("textarea");
      for (let i = 0; i < tx.length; i++) {
        tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;overflow-y:hidden;");
        tx[i].addEventListener("input", OnInput, false);
      }
      
      function OnInput() {
        this.style.height = "auto";
        this.style.height = (this.scrollHeight) + "px";
      }}
    
     
    
    
    //check if can play opus----------------------------------------------------
    const audio  = document.createElement("audio"),
    canPlayOPUS =audio.canPlayType('audio/webm;codecs="opus"') !== "";
    
    
    //check if not an emptyquestion
    function emptyQuestion(){
    const enteredQuestion=questRef.current.value;
    const noWhiteEmptySpaces=enteredQuestion.replace(/\n*$/g, "").replace(/\s/g,"");
      return ((audioUrl==='' && imgUrl==='' && noWhiteEmptySpaces===''));
    }
    
      return (
            <div>
                         
            <div className={d132.MainContainer} >
           
             
             
    
             
               <p className={d132.p}><IoText className={d132.formIcons}/>Add text <br/> 
                <textarea onChange={textareaResize} type='text'  ref={questRef} placeholder="enter question here" required/></p>
               
    
               <p className={d132.p}><BsImageFill className={d132.formIcons}/>Add image {!imgUpState && <> { Number((imgProgress).toFixed(1))}%  <RiLoader4Line className={d132.uploadIcon}/> </>} </p>
               <div className={d132.imageInput}>

               <label htmlFor="file-upload" className={d132.inputLabel}>
<IoImagesOutline className={d132.formIcons} /> 
</label>

                <input hidden id='file-upload' type='file' accept="image/*" ref={imgRef} onChange={() => { handleImgUpload(); setImgUpState(false);  getImagePreview();}}/>
               {imagePreview &&<Image src={imagePreview} className={d132.imagePreview}/>  }  
              </div>      
              
    
               <p className={d132.p}><AiTwotoneAudio className={d132.formIcons}/>Add audio  {!audioUpState && <> {Number((audioProgress).toFixed(1))}%  <RiLoader4Line  className={d13.uploadIcon}/></>}</p>
               
                       
                <div className={d13.audioInput}> 
               
             { !canPlayOPUS? //check broswer if safari render a special component
             <div>
              <button onClick={()=>handleAudioUpload(audioRef.current.files[0])}>upload</button>
              <button  onClick={()=>{setAudioPreview('');audioRef.current.value=null}}> clear</button>
              <input type='file' accept="audio/*"ref={audioRef} capture onChange={()=>getAudioPreview()}/>
              <audio controls src={audioPreview}  /></div> :
    
              <RecorderHooks getBolb={b=>{handleAudioUpload(b);}}/>
             }
    
              </div>
    
              <div ref={scroll}></div>
    
             <p>
               {loader && 'sending...'}
            { (!audioUpState || !imgUpState) && 'please wait while uploading media'}
            { audioUpState && imgUpState && !loader && <button className={d132.UploadButton} onClick={()=>emptyQuestion()?toast.error('cannot add empty questions'):sendQuestion()}
           
            >Leave Note <BsFillReplyAllFill size='16' style={{'marginLeft':'5px'}}/></button>
            //
          }
           
               </p>
              
            </div>
           
            </div>
              )
    }
    
    export default QuestionNoteForm
    